/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IOrderLevelCommentViewProps } from './order-level-comment';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IOrderLevelCommentViewProps) => {
    const { staticDisplay, orderLevelCommentModuleProps, modal } = props;
    return (
        <Module {...orderLevelCommentModuleProps}>
            {modal}
            <Node {...staticDisplay} />
        </Module>
    );
};
